<template>
  <div class="team-creation-section">
    <Icon name="empty-flag" />
    <div class="team-creation-section__heading">
      Создайте команду своего клуба<br>или ЗОЖ-сообщества
    </div>
    <Button
      variant="primary"
      size="lg"
      text="Создать команду"
      @click="$emit('create-team')"
    />
  </div>
</template>

<script>
export default {
  name: 'TeamCreationSection',
  emits: ['create-team'],
};
</script>

<style lang="scss" scoped>
.team-creation-section {
  width: 100%;
  padding: 48px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: $color-white;
  gap: 18px;

  @media (min-width: breakpoint(md)) {
    flex-direction: row;
    padding: 64px;
  }

  ::v-deep .rr-icon {
    flex: 0 0 auto;
    width: 48px;
    height: 48px;
    color: var(--color-primary, #FF8233);
    margin-right: 20px;
  }

  ::v-deep .rr-button {
    border-radius: 4px;
  }

  &__heading {
    width: 100%;
    font-size: 20px;
    line-height: 24px;
    font-weight: bold;
    color: $color-black;
    text-align: center;

    @media (min-width: breakpoint(md)) {
      text-align: start;
    }
  }
}
</style>
